module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-1",
    attrs: {
      "id": "_idParaDest-6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CHEP_Chapter_epigraph_prose ParaOverride-1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("be")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("laid")]), _vm._v(" schemes o’ mi"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ce and men")])]), _vm._v(" "), _c('p', {
    staticClass: "CHEP_Chapter_epigraph_prose ParaOverride-1"
  }, [_vm._v("Gang"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" a")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" agley")])]), _vm._v(" "), _c('p', {
    staticClass: "CHE1_Chapter_epigraph_other_1 ParaOverride-9"
  }, [_c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "Serif_SmallCaps CharOverride-4"
  }, [_vm._v("To a Mouse")])])]), _vm._v(" "), _c('p', {
    staticClass: "CHE1_Chapter_epigraph_other_1 ParaOverride-10"
  }, [_c('span', {
    staticClass: "Serif_SmallCaps CharOverride-5"
  }, [_vm._v("Ro")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "Serif_SmallCaps CharOverride-5"
  }, [_vm._v("bert Burns")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-610f4856","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-5.vue
// module id = 78
// module chunks = 0